import React from 'react';
import HeaderTabs from '../headerTabs/headerTabs';
import PropTypes from 'prop-types';

const SubLayout = ({ children }) => {

    return (
        <>
            <HeaderTabs />
            <div className="content-desc-section">
                <div className="center-container">
                    {children}
                </div>
            </div>
        </>
    )
};
SubLayout.propTypes = {
    children: PropTypes.node.isRequired,  // Ensures that children are passed and are valid React nodes
};

export default SubLayout